import * as React from 'react';
import {WithStyles, withStyles,} from '@material-ui/core';
import TranslateNew from '@translate/TranslateNew';
import { VVTimePickerStyle } from './timepicker.style';
import { styleColors } from 'src/main.style';

const tn: TranslateNew = TranslateNew.getInstance();

interface IProps extends WithStyles<typeof VVTimePickerStyle> {
  open:boolean;
  hour:number;
  minute:number;
  setHour:(hour:number) => void;
  setMinute:(minute:number) => void;

  isFullDay?:boolean;
  fullDayOption?:boolean;
  setFullDay?:() => void;
}

class VVTimePicker extends React.Component<IProps> {

  private scrollMinuteRef: React.RefObject<HTMLDivElement> = React.createRef();
  private touchStartY = 0;
  private touchStartTop = 0;

  private scrollMinuteRefValues: Array<React.RefObject<HTMLDivElement>> = [React.createRef(),React.createRef(),React.createRef(),
    React.createRef(),React.createRef(),React.createRef(),React.createRef(),React.createRef(),React.createRef(),React.createRef(),
    React.createRef(),React.createRef()];

  private scrollHourRef: React.RefObject<HTMLDivElement> = React.createRef();

  private scrollHourRefValues: Array<React.RefObject<HTMLDivElement>> = [
    React.createRef(),React.createRef(),React.createRef(),React.createRef(),React.createRef(),React.createRef(),
    React.createRef(),React.createRef(),React.createRef(),React.createRef(),React.createRef(),React.createRef(),
    React.createRef(),React.createRef(),React.createRef(),React.createRef(),React.createRef(),React.createRef(),
    React.createRef(),React.createRef(),React.createRef(),React.createRef(),React.createRef(),React.createRef(),];

  private scrollAmPmRef: React.RefObject<HTMLDivElement> = React.createRef();
  private scrollAmRef:React.RefObject<HTMLDivElement> = React.createRef();
  private scrollPmRef:React.RefObject<HTMLDivElement> = React.createRef();

  // NEW: small helper to snap wheel scrolling (no layout changes)
  private wheelSnapTimeout?: number;
  private readonly STEP = 34;

  public componentDidMount() {
    this.reset();
  }

  public componentDidUpdate(prevProps:IProps) {
    if (this.props.open !== prevProps.open) {
      this.reset();
    }
  }

  public renderOptions(nomOption:number) {
    const elements:JSX.Element[] = [];
    for (let index = 0; index < nomOption; index++) {
      elements.push(<div className={this.props.classes.scrollOption} key={index}
        onClick={(e) => e.currentTarget.scrollIntoView({behavior:"smooth", block:"center"})}/>)
    }
    return elements;
  }

  public render() {
    const {classes, open} = this.props;

    const locale: string = navigator.language || (navigator as any).language?.[0] || "sv-SE";

    const amPMTime = locale.startsWith('en-US');

    return (<>
      
      <div className={classes.timePicker} style={{maxHeight:(open?170:0),minHeight:(open?170:0)}}>
        <div className={classes.timepickerViewport} style={{maxWidth:(amPMTime?150:100)}}>
          <div
            className={classes.scrollPane}
            onScroll={this.handleScrollHour}
            // onTouchStartCapture={(e) => this.onTouchStart(e, this.scrollHourRef.current)} // fallback pan
            // onTouchMoveCapture={(e) => this.onTouchMove(e, this.scrollHourRef.current)}    // fallback pan
            onWheel={(e)=>this.handleWheel(this.scrollHourRef, e)}
            ref={this.scrollHourRef}
          >
            {this.renderOptions(72)}
          </div>
          <div
            className={classes.scrollPane}
            style={{left:50}}
            // onTouchStartCapture={(e) => this.onTouchStart(e, this.scrollMinuteRef.current)} // fallback pan
            // onTouchMoveCapture={(e) => this.onTouchMove(e, this.scrollMinuteRef.current)}    // fallback pan
            onScroll={this.handleScrollMinute}
            onWheel={(e)=>this.handleWheel(this.scrollMinuteRef, e)}
            ref={this.scrollMinuteRef}
          >
            {this.renderOptions(48)}
          </div>
          {amPMTime && <div
            className={classes.scrollPane}
            style={{left:100}}
            // onTouchStartCapture={(e) => this.onTouchStart(e, this.scrollAmPmRef.current)} // fallback pan
            // onTouchMoveCapture={(e) => this.onTouchMove(e, this.scrollAmPmRef.current)}    // fallback pan
            onScroll={this.handleScrollAmPm}
            onWheel={(e)=>this.handleWheel(this.scrollAmPmRef, e)}
            ref={this.scrollAmPmRef}
          >
            {this.renderOptions(6)}
          </div>}
          <div className={classes.wheelMarker} style={this.props.isFullDay?{backgroundColor:styleColors.white}
            :{width:(amPMTime?120:70)}}>:</div>
          <div className={classes.wheel} >
            <div className={classes.option} ref={this.scrollHourRefValues[0]}  >{amPMTime?11:23}</div>
            <div className={classes.option} ref={this.scrollHourRefValues[1]}  >{amPMTime?10:22}</div>
            <div className={classes.option} ref={this.scrollHourRefValues[2]}  >{amPMTime?9:21}</div>
            <div className={classes.option} ref={this.scrollHourRefValues[3]}  >{amPMTime?8:20}</div>
            <div className={classes.option} ref={this.scrollHourRefValues[4]}  >{amPMTime?7:19}</div>
            <div className={classes.option} ref={this.scrollHourRefValues[5]}  >{amPMTime?6:18}</div>
            <div className={classes.option} ref={this.scrollHourRefValues[6]}  >{amPMTime?5:17}</div>
            <div className={classes.option} ref={this.scrollHourRefValues[7]}  >{amPMTime?4:16}</div>
            <div className={classes.option} ref={this.scrollHourRefValues[8]}  >{amPMTime?3:15}</div>
            <div className={classes.option} ref={this.scrollHourRefValues[9]}  >{amPMTime?2:14}</div>
            <div className={classes.option} ref={this.scrollHourRefValues[10]} >{amPMTime?1:13}</div>
            <div className={classes.option} ref={this.scrollHourRefValues[11]} >12</div>
            <div className={classes.option} ref={this.scrollHourRefValues[12]} >11</div>
            <div className={classes.option} ref={this.scrollHourRefValues[13]} >10</div>
            <div className={classes.option} ref={this.scrollHourRefValues[14]} >9</div>
            <div className={classes.option} ref={this.scrollHourRefValues[15]} >8</div>
            <div className={classes.option} ref={this.scrollHourRefValues[16]} >7</div>
            <div className={classes.option} ref={this.scrollHourRefValues[17]} >6</div>
            <div className={classes.option} ref={this.scrollHourRefValues[18]} >5</div>
            <div className={classes.option} ref={this.scrollHourRefValues[19]} >4</div>
            <div className={classes.option} ref={this.scrollHourRefValues[20]} >3</div>
            <div className={classes.option} ref={this.scrollHourRefValues[21]} >2</div>
            <div className={classes.option} ref={this.scrollHourRefValues[22]} >1</div>
            <div className={classes.option} ref={this.scrollHourRefValues[23]} >{amPMTime?12:0}</div>
          </div>
          <div className={classes.wheel} >
            <div className={classes.option} ref={this.scrollMinuteRefValues[0]} >00</div>
            <div className={classes.option} ref={this.scrollMinuteRefValues[1]} >55</div>
            <div className={classes.option} ref={this.scrollMinuteRefValues[2]} >50</div>
            <div className={classes.option} ref={this.scrollMinuteRefValues[3]} >45</div>
            <div className={classes.option} ref={this.scrollMinuteRefValues[4]} >40</div>
            <div className={classes.option} ref={this.scrollMinuteRefValues[5]} >35</div>
            <div className={classes.option} ref={this.scrollMinuteRefValues[6]} >30</div>
            <div className={classes.option} ref={this.scrollMinuteRefValues[7]} >25</div>
            <div className={classes.option} ref={this.scrollMinuteRefValues[8]} >20</div>
            <div className={classes.option} ref={this.scrollMinuteRefValues[9]} >15</div>
            <div className={classes.option} ref={this.scrollMinuteRefValues[10]} >10</div>
            <div className={classes.option} ref={this.scrollMinuteRefValues[11]} >05</div>
          </div>
          {amPMTime && <div className={classes.wheel} >
            <div className={classes.option} ref={this.scrollAmRef} >AM</div>
            <div className={classes.option} ref={this.scrollPmRef} >PM</div>
          </div>}
        </div>
      </div>
      {this.props.fullDayOption && <div className={this.props.isFullDay?classes.fullDaySelected:classes.fullDay}
        onClick={this.props.setFullDay} >
        {tn.lang.timePickerFullDay}
      </div>}
      </>
    );
  }

  private reset = () => {
    if (this.scrollAmPmRef.current) {
      this.scrollAmPmRef.current.scrollTop = this.props.hour >= 12?this.STEP:0;
    }
    if (this.scrollHourRef.current) {
      this.scrollHourRef.current.scrollTop = this.STEP*(24+this.props.hour+1);
    }
    this.handleScrollHour();
    if (this.scrollMinuteRef.current) {
      this.scrollMinuteRef.current.scrollTop = this.STEP*(12+Math.abs(this.props.minute/5));
    }
    this.handleScrollMinute();
  }

  // Fallback pan handlers
  private onTouchStart = (e: React.TouchEvent<HTMLDivElement>, el:any) => {
    // const el = this.scrollDateRef.current;
    if (!el) return;
    this.touchStartY = e.touches[0].clientY;
    this.touchStartTop = el.scrollTop;
  };

  private onTouchMove = (e: React.TouchEvent<HTMLDivElement>, el:any) => {
    // const el = this.scrollDateRef.current;
    if (!el) return;

    const dy = e.touches[0].clientY - this.touchStartY;
    const prev = el.scrollTop;
    el.scrollTop = this.touchStartTop - dy;

    // If we actually scrolled the inner element, keep the gesture here.
    if (el.scrollTop !== prev) {
      e.stopPropagation();  // don’t let body/page handlers hijack it
      e.preventDefault();   // prevent page scroll while we pan the inner scroller
    }
  };

  // NEW: wheel → snap exactly one item (34px) per tick, then snap to nearest step
  private handleWheel = (ref: React.RefObject<HTMLDivElement>, e: React.WheelEvent) =>  {
    const el = ref.current;
    if (!el) return;
    e.preventDefault();

    const dir = e.deltaY > 0 ? 1 : -1;
    el.scrollTop = el.scrollTop + dir * this.STEP;

    // quick snap to nearest step to avoid in-between positions
    window.clearTimeout(this.wheelSnapTimeout);
    this.wheelSnapTimeout = window.setTimeout(() => {
      const nearest = Math.round(el.scrollTop / this.STEP) * this.STEP;
      el.scrollTop = nearest;
    }, 60);
  }

  private handleScrollMinute = () =>  {
    const {setHour, setMinute, hour, minute} = this.props;

    const container = this.scrollMinuteRef.current;
    if (container) {
      const scrollDegrees = (((container.scrollTop*30) / this.STEP) % 360);
      const stepsScrolledDown = ((Math.round(container.scrollTop / this.STEP))%12);
      let selectedIndex = 12- stepsScrolledDown;
      if (selectedIndex === 12) {selectedIndex = 0;}
      
      const scrolledToMinutes = (stepsScrolledDown * 5);
      if (scrolledToMinutes !== minute) {
        setMinute(scrolledToMinutes);
      }

      let i = 0;
      for (const ref of this.scrollMinuteRefValues) {
        if (ref.current) {

          const directDistance = Math.abs(i - selectedIndex);
          const loopedDistance = (12 - directDistance);
          const distance = Math.min(directDistance, loopedDistance);

          if (distance <= 3) {
            ref.current.style.transform = `rotateX(${(30 * i)+scrollDegrees}deg) translateZ(70px)`;
            ref.current.style.color = (selectedIndex === i)?styleColors.black:'#bbbbbb';  
            ref.current.style.opacity = "1";
          } else {
            ref.current.style.opacity = "0";
          }
        }
        i++;
      }
    }
  }


  private handleScrollAmPm = () =>  {
    const {setHour, setMinute, hour, minute} = this.props;

    const container = this.scrollAmPmRef.current;
    if (container) {
      const amPm = (Math.round(container.scrollTop / this.STEP)); // 0 = AM, 1 = PM
      let newHour = hour;

      if (hour >= 12 && amPm === 0) {
        newHour = hour - 12;
      } else if (hour < 12 && amPm === 1) {
        newHour = hour + 12;
      }
      setHour(newHour);
  
      if (this.scrollHourRef.current) {
        this.scrollHourRef.current.scrollTop = this.STEP*(24+newHour+1);
      }
    }
  }

  private handleScrollHour = () =>  {
    const {setHour, setMinute, hour, minute} = this.props;

    const container = this.scrollHourRef.current;
    if (container) {
      const scrollDegrees = ((container.scrollTop*30) / this.STEP);
      const stepsScrolledDown = ((Math.round(container.scrollTop / this.STEP))%24);
      let selectedIndex = 24- stepsScrolledDown;
      if (selectedIndex === 24) {selectedIndex = 0;}

      const scrolledToHour = (stepsScrolledDown === 0)?23:(stepsScrolledDown -1);
      
      if (scrolledToHour !== hour) {
        setHour(scrolledToHour);
      }

      let i = 0;
      for (const ref of this.scrollHourRefValues) {
        if (ref.current) {

          const directDistance = Math.abs(i - selectedIndex);
          const loopedDistance = (24 - directDistance);
          const distance = Math.min(directDistance, loopedDistance);

          if (distance <= 3) {
            ref.current.style.transform = `rotateX(${(30 * i)+scrollDegrees}deg) translateZ(70px)`;
            ref.current.style.color = (selectedIndex === i)?styleColors.black:'#bbbbbb';  
            ref.current.style.opacity = "1";
          } else {
            ref.current.style.opacity = "0";
          }
        }
        i++;
      }

      if (this.scrollAmRef.current && this.scrollPmRef.current && this.scrollAmPmRef.current) {

        this.scrollAmPmRef.current.scrollTop = (scrolledToHour >= 12?this.STEP:0);

        this.scrollAmRef.current.style.transform = `rotateX(${scrolledToHour >= 12?this.STEP:0}deg) translateZ(70px)`;
        this.scrollAmRef.current.style.color = (scrolledToHour >= 12)?'#bbbbbb':styleColors.black;  
        this.scrollAmRef.current.style.transition = 'transform 0.1s';  

        this.scrollPmRef.current.style.transform = `rotateX(${scrolledToHour >= 12?0:-this.STEP}deg) translateZ(70px)`;
        this.scrollPmRef.current.style.color = (scrolledToHour >= 12)?styleColors.black:'#bbbbbb';  
        this.scrollPmRef.current.style.transition = 'transform 0.1s';  
      }
    }
  }

}

export default withStyles(VVTimePickerStyle)(VVTimePicker);



// WEBPACK FOOTER //
// ./src/components/common/timepicker/VVTimePicker.tsx